export default {
  'operation.manageAccount': '账号管理',
  'operation.proxyAccount': '模拟其他账户',
  'operation.resetPassword': '更改密码',
  'operation.logout': '登出',
};
